import TW from '@naruto/bgdapp/src/langs/data/tw';
import En from '@naruto/bgdapp/src/langs/data/en';
import { LangAvailableList } from './types';

export default [
  {
    name: 'tw',
    value: 'tw',
    translate: TW
  },
  {
    name: 'en',
    value: 'en',
    translate: En
  }
] as LangAvailableList;
